import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";
import {
  updateProposalForm,
  readData,
  checkAllRequiredDocumentsUploaded,
} from "../OrderService";
import { denormalizeProposalRecord } from "./useProposalFormData";
import { openProposal } from "../../../../slices/common/reducer";
import { showToast } from "../../../../common/Toaster/Toaster";

// Mirrors ProposalModal.js's handleSubmit final-step branch: same
// updateProposalForm(entity, entityid, entitytype, status, proposal_filled)
// call. proposal_filled is set to 1 ONLY if all required documents have been uploaded,
// otherwise 0.
const useSubmitProposalForm = (orderId, detailsData) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const fields = useSelector((state) => state.order.ProposalFieldsJSON);

  return useMutation({
    mutationFn: (values) => {
      const denormalizedRecord = denormalizeProposalRecord(values, fields);
      const allDocsUploaded = checkAllRequiredDocumentsUploaded(
        denormalizedRecord,
        fields
      );
      const proposalFilledFlag = allDocsUploaded ? 1 : 0;

      return updateProposalForm(
        denormalizedRecord,
        detailsData?.entityid,
        "ODR",
        detailsData?.status,
        proposalFilledFlag
      );
    },
    onSuccess: async (response) => {
      if (response?.status !== 200) return;
      showToast("Proposal form updated successfully", "success");
      await readData(orderId, "ODR");
      queryClient.invalidateQueries({
        queryKey: ["proposalFormData", orderId],
      });
      dispatch(openProposal(false));
    },
    onError: (error) => {
      const errorMessage =
        error?.response?.data?.error_message || "An error occurred";
      showToast(errorMessage, "error");
    },
  });
};

export default useSubmitProposalForm;
